// Re-export shared card constants for backwards compat with consumers that
// import them from "eone-ui/tables/table-constants".
export {
    BadgeAlignment,
    BadgeStyle,
    CardIconType
} from "../cards/card-constants";

export const TableFieldType = {
    String: 1,
    Select: 2,
    Checkbox: 3,
    Date: 4,
    Integer: 5,
    Color: 6,
    Image: 7,
    Time: 8,
    DateTime: 9,
    MultiValue: 10,
    Percent: 11,
    Quantity: 12,
    Tags: 13,
    RowBackgroundColour: 14,
    RowTextColour: 15,
}

export const TableAlignment = {
    Left: 1,
    Right: 2,
    Center: 3
}

export const TableSortDirection = {
    None: 0,
    Ascending: 1,
    Descending: 2
}

export const TableViewMode = {
    Grid: 1,
    Cards: 2
}

export const CardPosition = {
    None: 0,
    Title: 1,
    Subtitle: 2,
    Body: 3,
    Badge: 4,
    Icon: 5
}

export const TableRowCheckboxStyleOverrides = {
    ["--pd-checkbox-height"]: "13px",
    ["--pd-checkbox-width"]: "13px"
};
